import type { Dispatch, ReactNode, SetStateAction } from 'react';
import React, { useState, useEffect, createContext } from 'react';

export type Locale = string;

interface LocaleContextValue {
  locale: Locale;
  setLocale: Dispatch<SetStateAction<Locale>>;
}

interface LocaleProviderProps {
  lang: Locale;
  children: ReactNode;
}

export const LocaleContext = createContext<LocaleContextValue>({
  locale: 'ru',
  setLocale: () => null,
});

export const LocaleProvider = ({ lang, children }: LocaleProviderProps) => {
  const [locale, setLocale] = useState<Locale>(lang);

  useEffect(() => {
    if (locale !== localStorage.getItem('locale')) {
      localStorage.setItem('locale', locale);
    }
  }, [locale]);

  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
      {children}
    </LocaleContext.Provider>
  );
};
